export default __webpack_public_path__ + "static/services3-818388704a4119db9449d4d61e3b8952.png";